import { z } from 'zod';

/**
 * EU-593 — search params da rota /programas/$programId (Gerenciar programa).
 * Aba, busca e paginação são shareáveis via URL; os 11 campos do drawer de
 * filtro vivem em estado local do container (chips de localidade/curso
 * carregam LABELS resolvidos por autocomplete — ids crus na URL perderiam o
 * rótulo no cold-load; decisão consciente, espelhada no comentário do
 * container).
 */
export const programManagementSearchSchema = z.object({
  companyId: z.string().optional().catch(undefined),
  tab: z.string().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  page: z.coerce.number().int().positive().optional().catch(undefined),
  pageSize: z.coerce.number().int().positive().max(100).optional().catch(undefined),
});

export type ProgramManagementSearch = z.infer<typeof programManagementSearchSchema>;

export const PROGRAM_MANAGEMENT_PAGE_SIZES = [8, 16, 25, 50, 100];
export const PROGRAM_MANAGEMENT_DEFAULT_PAGE_SIZE = 8;
